import React from 'react';
import Icon from '../../../components/AppIcon';

const ContentTypeSelector = ({ selectedType, onTypeChange }) => {
  const contentTypes = [
    {
      id: 'text',
      label: 'Text',
      icon: 'Type',
      description: 'Plain text or paragraph'
    },
    {
      id: 'url',
      label: 'URL',
      icon: 'Link',
      description: 'Website or web link'
    },
    {
      id: 'wifi',
      label: 'Wi-Fi',
      icon: 'Wifi',
      description: 'Network credentials'
    },
    {
      id: 'contact',
      label: 'Contact',
      icon: 'User',
      description: 'vCard information'
    },
    {
      id: 'email',
      label: 'Email',
      icon: 'Mail',
      description: 'Email message'
    },
    {
      id: 'sms',
      label: 'SMS',
      icon: 'MessageSquare',
      description: 'Text message'
    }
  ];

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Layers" size={20} color="var(--color-accent)" strokeWidth={2} />
        <h3 className="text-base font-heading font-semibold text-foreground">
          Select Content Type
        </h3>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-2 gap-3">
        {contentTypes?.map((type) => (
          <button
            key={type?.id}
            onClick={() => onTypeChange(type?.id)}
            className={`
              relative p-4 rounded-xl border-2 transition-smooth text-left
              ${selectedType === type?.id
                ? 'border-accent bg-accent/5 shadow-warm-sm'
                : 'border-border bg-card hover:border-accent/50 hover:bg-muted/30'
              }
            `}
          >
            <div className="flex items-start gap-3">
              <div className={`
                w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0
                ${selectedType === type?.id ? 'bg-accent/10' : 'bg-muted'}
              `}>
                <Icon
                  name={type?.icon}
                  size={20}
                  color={selectedType === type?.id ? 'var(--color-accent)' : 'var(--color-muted-foreground)'}
                  strokeWidth={2}
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-heading font-semibold text-sm text-foreground mb-0.5">
                  {type?.label}
                </div>
                <div className="text-xs font-caption text-muted-foreground line-clamp-1">
                  {type?.description}
                </div>
              </div>
            </div>
            {selectedType === type?.id && (
              <div className="absolute top-2 right-2">
                <div className="w-5 h-5 rounded-full bg-accent flex items-center justify-center">
                  <Icon name="Check" size={12} color="var(--color-accent-foreground)" strokeWidth={3} />
                </div>
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ContentTypeSelector;